import { ApolloClient, InMemoryCache, HttpLink, ApolloLink, QueryOptions, OperationVariables } from "@apollo/client";
import { buildTime, Config } from "../../Config";
import { RetryLink } from "apollo-link-retry";
import { createPersistedQueryLink } from "apollo-link-persisted-queries";
// Config.isGraphQLAPQ = false;

const persistedLink = createPersistedQueryLink({
    useGETForHashedQueries: true,
    generateHash: doc => {
        return doc.definitions[0]["name"]["value"] as string;
    }
});

const retryLink = new RetryLink({
    delay: {
        initial: 300,
        max: Infinity,
        jitter: true
    },
    attempts: {
        max: 5,
        retryIf: (error, _operation) => !!error
    }
});

const httpLink = new HttpLink({ uri: `${Config.graphQLEndpoint}?buildTime=${buildTime}` });
// Config.isGraphQLAPQ = true;
const apolloParams = [
    Config.isGraphQLAPQ ? (persistedLink as unknown as ApolloLink) : undefined,
    retryLink as unknown as ApolloLink,
    httpLink
    // new ApolloLink((operation, forward) => {
    //     operation.setContext({ start: new Date() });
    //     return forward(operation);
    // })
].filter(option => option !== undefined);

const link = ApolloLink.from(apolloParams);

export const client = new ApolloClient({
    cache: new InMemoryCache(),
    link
});

export const queryEntities = async <T, J>(
    options: QueryOptions<
        OperationVariables,
        {
            // query: {
            //     entities: T[];
            // };
            result: T[];
        }
    >,
    transform: (entities: T[]) => J[] = (arg = []) => arg as unknown as J[]
): Promise<J[]> => {
    try {
        const data = await client.query(options);
        const entities = data?.data?.result ?? [];

        return transform(entities);
    } catch (err) {
        console.log(err);
    }

    return undefined;
};

export const queryCount = async <T,>(
    options: QueryOptions<
        OperationVariables,
        {
            // query: {
            //     entities: T[];
            // };
            result: T[];
        }
    >
): Promise<number> => {
    try {
        const data = await client.query(options);
        return data?.data?.result?.length;
    } catch (err) {
        console.log(err);
    }

    return undefined;
};
